import {
  CampaignTypesCardEcho,
  CampaignsCardEcho,
  InfoMessageCardEcho,
  NetworkProfileCardEcho,
  EstimatedEarningsCardEcho,
  ShowPerformanceCardEcho,
  TotalEstimatedEarningsCardEcho,
  TotalEstimatedImpressionsCardEcho,
  TopAdvertisersCardEcho,
  FilterCardEcho,
  DownloadDrawerTriggerEcho,
} from '@/components';
import type { CSSProperties } from 'react';
import { VisibleFilterKey } from '@/components/cards/FilterCard/Filters';
import { cardFullWidth, cardOneThird, cardTwoThirds } from '@/utils/styleUtils';
import { useFilterContext, useDerivedNetworkContext } from '@/context';
import { useSyncUrlToFilters } from '@/hooks/useSyncUrlToFilters';
import { Col, Flex, Grid, Row, Typography, theme } from 'antd';

const EarningsPageEcho = () => {
  const { Title } = Typography;
  const { token } = theme.useToken();
  const screens = Grid.useBreakpoint();
  const isMediumScreen = Boolean(screens.md);
  const { filters } = useFilterContext();
  const { selectedNetwork } = useDerivedNetworkContext();
  const { shows } = selectedNetwork;
  const noOfShows = shows?.length ?? 0;
  const visibleFilters: VisibleFilterKey[] =
    noOfShows > 1
      ? [VisibleFilterKey.Networks, VisibleFilterKey.Shows, VisibleFilterKey.DateRange]
      : [VisibleFilterKey.Networks, VisibleFilterKey.DateRange];
  const isShowFilterEnabled = filters.selectedShows.length > 0;

  useSyncUrlToFilters();

  const earningsCardGridStyle: CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
    columnGap: token.marginLG,
    rowGap: token.marginLG,
    width: '100%',
  };

  return (
    <>
      <Flex
        vertical={!isMediumScreen}
        justify="space-between"
        style={{
          width: '100%',
          paddingTop: token.paddingLG,
          paddingBottom: 40,
        }}
      >
        <Title level={1}>Realtime earnings</Title>
        <Flex justify="flex-end" style={{ width: isMediumScreen ? undefined : '100%' }}>
          <DownloadDrawerTriggerEcho />
        </Flex>
      </Flex>

      <FilterCardEcho visibleFilters={visibleFilters} />

      <Row style={{ marginBottom: token.marginLG }}>
        <Col span={24} style={earningsCardGridStyle}>
          <NetworkProfileCardEcho visibleFilters={visibleFilters} className={cardFullWidth} />
        </Col>
      </Row>

      <Row>
        <Col span={24} style={earningsCardGridStyle}>
          <TotalEstimatedEarningsCardEcho className={cardTwoThirds} />
          <TotalEstimatedImpressionsCardEcho className={cardOneThird} />
          <InfoMessageCardEcho className={cardFullWidth} />
          <EstimatedEarningsCardEcho
            className={noOfShows > 1 && !isShowFilterEnabled ? cardTwoThirds : cardFullWidth}
          />
          {noOfShows > 1 && !isShowFilterEnabled && (
            <ShowPerformanceCardEcho className={cardOneThird} />
          )}
          <CampaignTypesCardEcho className={cardTwoThirds} />
          <TopAdvertisersCardEcho className={cardOneThird} />
          <CampaignsCardEcho className={cardFullWidth} />
        </Col>
      </Row>
    </>
  );
};

export default EarningsPageEcho;
